import { FieldsToLookupByMasterAttributeId, IFlexibleFieldWithAttributes } from "global/Application";
import {
    IBenefit as FAM_IBenefit,
    IEntityReferenceValue as FAM_IEntityReferenceValue,
    IFlexibleFieldValue as FAM_IFlexibleFieldValue,
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData
} from "model/FlexibleAttributeModel";
import { v4 as uuidv4 } from 'uuid';
import { Memoize, parseDate } from "../Utility/TSFunctions";
import { BaseJsonTransformer } from "./IJsonTransformer";
import { ENotificationName } from "views/BlueRelationship/Controls/ActionItemsPanel/ActionItemsPanel";
import * as IXrmOptions from "model/AttributeOptionSets.type";
import { EHideReason } from "global/Visibility/EHideReason";
import { debug } from "console";
import { $matt_$medical_$bcbs_areinfertilityservicessubjecttoanymaximum_id, $matt_$medical_$bcbs_aso_hearingaidhearingexamsunitmaxamt_id, $matt_$medical_$bcbs_aso_nutritionalcounselingdaymaxamt_id, $matt_$medical_$bcbs_aso_nutritionalcounselingdaymaxapplies_id, $matt_$medical_$bcbs_aso_nutritionalcounselingvisitmaxamt_id, $matt_$medical_$bcbs_aso_nutritionalcounselingvisitmaxapplies_id, $matt_$medical_$bcbs_aso_pdndaymaxamt_id, $matt_$medical_$bcbs_aso_pdndaymaxappliesper_id, $matt_$medical_$bcbs_aso_pdnvisitmaxamt_id, $matt_$medical_$bcbs_aso_pdnvisitmaxappliesper_id, $matt_$medical_$bcbs_bp_contractmax_id, $matt_$medical_$bcbs_chiro_mon_or_max_id, $matt_$medical_$bcbs_chiro_mon_or_max_limit_id, $matt_$medical_$bcbs_chiromonetarylimit_id, $matt_$medical_$bcbs_chirovisitlimit_id, $matt_$medical_$bcbs_cochlearmaximum_id, $matt_$medical_$bcbs_hearingaidexamsmaximumvisits_id, $matt_$medical_$bcbs_homehealthvisitmax_id, $matt_$medical_$bcbs_hot_donormaximum_id, $matt_$medical_$bcbs_hot_donorsubjecttomax_id, $matt_$medical_$bcbs_hot_recipientmaximum_id, $matt_$medical_$bcbs_hot_recipientsubjecttomax_id, $matt_$medical_$bcbs_ifyesbenefitperiodmaximumsishomehealth_id, $matt_$medical_$bcbs_ifyesbenefitperiodmaximumsisinfertility_id, $matt_$medical_$bcbs_ifyespleaseindicateanyapplicablemaxdonor_id, $matt_$medical_$bcbs_ifyespleaseindicateanyapplicablemaxtrav_id, $matt_$medical_$bcbs_infertilitymaxamt_id, $matt_$medical_$bcbs_infertilitymaxappliesper_id, $matt_$medical_$bcbs_ipbenfitperiodmaxsnf_id, $matt_$medical_$bcbs_ippenaltyamt_id, $matt_$medical_$bcbs_maximumdayshomehealthcare_id, $matt_$medical_$bcbs_nutritionalmaxvisits_id, $matt_$medical_$bcbs_pdn_visitmaximum_id, $matt_$medical_$bcbs_permembercontractmaximumperbenefitperio1_id, $matt_$medical_$bcbs_snfbp_maxdays_id, $matt_$medical_$bcbs_snfdaymaxapply_id } from "model/MasterAttributeConstants";
import { $att_$medical_$bcbs_applymaximumperd1_1d1858c9f151f011877a6045bdef1703_id, $att_$medical_$bcbs_applymaximumperd1_8470ab21d07aec118d21000d3a35957e_id, $att_$medical_$bcbs_applymaximumperdonor_8a70ab21d07aec118d21000d3a35957e_id, $att_$medical_$bcbs_applymaximumperdonor_c407a663f251f011877a6045bdef1703_id, $att_$medical_$bcbs_aso_cochlearimplantsunitmaxamt_id, $att_$medical_$bcbs_chiro_mon_or_max_c3e069d66c2bf0118c4c000d3a8f158d_id, $att_$medical_$bcbs_chiro_mon_or_max_f3ac0416076fec11894100224804a95e_id, $att_$medical_$bcbs_epo_chiropracticserviceslimitestoben_f1ac0416076fec11894100224804a95e_id, $att_$medical_$bcbs_epo_chiropracticserviceslimitestoben_ff680cfe6b2bf0118c4c000d3a8f158d_id, $att_$medical_$bcbs_outofnetworkpenaltyamount_id } from "model/ConfigAttributeConstants";
import { $oset_$chiro_type_of_limit_$monetary_max_per_benefit_period_id, $oset_$chiro_type_of_limit_$visit_limit_benefit_period_id, $oset_$os_max_applies_per_$benefit_period_id } from "model/ConfigOptionSetConstants";


/**
 * Transformers:
 * Moved from Sprint40BDSTransformer.ts
    https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/623228/
    https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/610573/
    https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/623745/
    https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/633058/
    https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/642016/ 
    https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/642098/
    https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643213/
    https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643548/
    https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643585/
 */
export class Sprint40Transformer extends BaseJsonTransformer {
    config: FAM_IGroupConfigurationConfig;
    json: FAM_IGroupConfigurationData;
    isASOFundingTypes: boolean;
    effectiveDt: number;
    BDSDt: number;
    isConfigurationED1012025: boolean;
    isFullyInsured: boolean;

    constructor({ config, json }: { config: FAM_IGroupConfigurationConfig, json: FAM_IGroupConfigurationData }) {
        super();
        this.config = config;

        this.json = json;


        this.isASOFundingTypes = this.json.fundingType?.value === IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode["Administrative Services Only(808900000)"].value ||
            this.json.fundingType?.value === IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode["ASO with Stop Loss(808900001)"].value ||
            this.json.fundingType?.value === IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode["National Alliance(808900003)"].value;

        this.isFullyInsured = this.json.fundingType?.value === IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode["Fully Insured(808900002)"].value;


        // Configuration ED 10/1/2025
        this.effectiveDt = parseDate(this.json!.effectiveDate!.value, 'yyyy-MM-ddThh:mm:ssZ as local').getTime();
        this.BDSDt = parseDate("2025-09-30", 'yyyy-MM-ddThh:mm:ssZ as local').getTime();

        this.isConfigurationED1012025 = this.effectiveDt > this.BDSDt;

    }

    private extractNumber(value: string): number | null {
        if (!value) return null;
        // Remove all non-digit, non-dot, non-comma, non-minus characters
        const cleaned = value.replace(/[^0-9.,-]/g, '');
        // Remove commas, handle decimals
        const normalized = cleaned.replace(/,/g, '');
        const num = parseFloat(normalized);
        return isNaN(num) ? null : num;
    }

    async before(json: FAM_IGroupConfigurationData): Promise<void> {
        console.debug("[tran] Sprint35Transformer.before")
    }


    async transformBenefit(benefit: FAM_IBenefit): Promise<boolean | void> {
        if (benefit.bcbs_config_categoryid !== this.config.cache.map_bcbs_config_category_named['Medical'].bcbs_config_categoryid)
            return;

        // cache list of fields upon first call
        const fieldInfosMemoized = Memoize(() => {
            return FieldsToLookupByMasterAttributeId(this.config, benefit.fields, undefined, true);
        });

        // Data Transformer - Medical Benefit - CONTRACT MAXIMUMS - Single Line Text to Currency Field
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/623748
        // Text to Currency
        {
            // Source:
            // Med - Contract Benefit Period Maximum
            // text/no-tier/no-pcp
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=5391d4e1-c24b-ec11-8f8e-000d3a3340f2
            const bcbs_permembercontractmaximumperbenefitperio1_mat = fieldInfosMemoized()[$matt_$medical_$bcbs_permembercontractmaximumperbenefitperio1_id];

            // Target:
            // Benefit Period Contract Maximum
            // currency
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=c41282dd-0722-f011-9989-6045bdef1703
            const bcbs_bp_contractmax_mat = fieldInfosMemoized()[$matt_$medical_$bcbs_bp_contractmax_id];

            const bcbs_permembercontractmaximumperbenefitperio1_value = bcbs_permembercontractmaximumperbenefitperio1_mat?.[0].field?.values?.[0].value?.type === "string"
                ? bcbs_permembercontractmaximumperbenefitperio1_mat?.[0].field?.values?.[0].value
                : null;

            const bcbs_bp_contractmax_mat_value = bcbs_bp_contractmax_mat[0].field.values?.[0];

            if (bcbs_permembercontractmaximumperbenefitperio1_value && bcbs_bp_contractmax_mat_value.value === null) {
                const valueNumber = this.extractNumber(bcbs_permembercontractmaximumperbenefitperio1_value.value);
                if (valueNumber !== null) {
                    bcbs_bp_contractmax_mat_value.value = {
                        type: "number",
                        value: valueNumber,
                    }
                }
            }

        }


        // Medical Benefit - Therapy - Chiro Limit: Value - FI - Change from Single Line Text to Monetary Field or Whole Number field Depending on Type of Limit
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/617975
        // Data Transformer - Medical Benefit - Chiro: Limit Value
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/617976
        // Test Case:
        // https://app-sys-eastus.grouplibrary.bcbssc.com/editor/records/blueRelationship/c3d9405c-1126-ec11-8ba3-00155dcb8702/groupConfiguration/442eecee-9da2-ef11-8a69-000d3a19328b/benefit/f1a3ad6f-3046-42cb-9717-a4ae7556a191/tab/9edf6811-0c43-ec11-8c60-000d3a5b8f01/section/05094262-8569-ec11-8941-00224804a216/field/f5ac0416-076f-ec11-8941-00224804a95e?navigation=complete
        // https://localhost:44350/editor/records/blueRelationship/c3d9405c-1126-ec11-8ba3-00155dcb8702/groupConfiguration/9d6fdbf3-7260-f011-bec2-7ced8d1a939d/benefit/2a328722-d1cc-4c59-91e4-bcadf9dd6ce5
        {
            {
                // Master Attribute:
                // Are chiropractic services limited to benefit period maximums or visit limits?
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=ac14b377-066f-ec11-8941-00224804a95e

                // Source:
                // Are chiropractic services limited to benefit period maximums or visit limits?
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=f1ac0416-076f-ec11-8941-00224804a95e
                const bcbs_has_maximum_mat = fieldInfosMemoized()[$att_$medical_$bcbs_epo_chiropracticserviceslimitestoben_f1ac0416076fec11894100224804a95e_id];

                // Target:
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=ff680cfe-6b2b-f011-8c4c-000d3a8f158d
                const bcbs_has_maximum2_mat = fieldInfosMemoized()[$att_$medical_$bcbs_epo_chiropracticserviceslimitestoben_ff680cfe6b2bf0118c4c000d3a8f158d_id];

                const bcbs_has_maximum_value = bcbs_has_maximum_mat?.[0].field?.values?.[0].value?.type === "bool"
                    ? bcbs_has_maximum_mat?.[0].field?.values?.[0].value
                    : null;

                const bcbs_has_maximum2_value = bcbs_has_maximum2_mat?.[0].field?.values?.[0];

                if (bcbs_has_maximum_value && bcbs_has_maximum2_value.value === null) {
                    bcbs_has_maximum2_value.value = {
                        type: "bool",
                        value: bcbs_has_maximum_value.value,
                    }
                }

            }

            {
                // Master Attribute:
                // Chiro: Type of limit
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=af14b377-066f-ec11-8941-00224804a95e

                // Source:
                // Chiro: Type of limit
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=f3ac0416-076f-ec11-8941-00224804a95e
                const bcbs_chiro_limit_type_mat = fieldInfosMemoized()[$att_$medical_$bcbs_chiro_mon_or_max_f3ac0416076fec11894100224804a95e_id];

                // Target:
                // Chiro Limit Type - FI
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=c3e069d6-6c2b-f011-8c4c-000d3a8f158d
                const bcbs_chiro_limit_type2_mat = fieldInfosMemoized()[$att_$medical_$bcbs_chiro_mon_or_max_c3e069d66c2bf0118c4c000d3a8f158d_id];

                const bcbs_chiro_limit_type_value = bcbs_chiro_limit_type_mat?.[0].field?.values?.[0].value?.type === "entity"
                    ? bcbs_chiro_limit_type_mat?.[0].field?.values?.[0].value
                    : null;

                const bcbs_chiro_limit_type2_value = bcbs_chiro_limit_type2_mat?.[0].field?.values?.[0];

                if (bcbs_chiro_limit_type_value && bcbs_chiro_limit_type2_value.value === null) {
                    bcbs_chiro_limit_type2_value.value = {
                        type: "entity",
                        id: bcbs_chiro_limit_type_value.id,
                        name: bcbs_chiro_limit_type_value.name,
                        entityType: bcbs_chiro_limit_type_value.entityType,
                    }
                }

            }

            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionset&id=a31aa08f-036f-ec11-8943-000d3a309e9b
            const Monetary: FAM_IEntityReferenceValue = {
                "type": "entity",
                "id": $oset_$chiro_type_of_limit_$monetary_max_per_benefit_period_id,
                "name": "Monetary max per benefit period",
                "entityType": "bcbs_config_optionsetitem"
            }
            const Visit: FAM_IEntityReferenceValue = {
                "type": "entity",
                "id": $oset_$chiro_type_of_limit_$visit_limit_benefit_period_id,
                "name": "Visit limit benefit period",
                "entityType": "bcbs_config_optionsetitem"
            }

            // Text to Currency but Conditional based on Chiro Type
            // Text to Whole Number but Conditional based on Chiro Type
            // Since the old field is expiring for ASO needed this one to continue to FI so the value needs to move from exired field to new FI only field


            // TODO check if another limit type is added and if we should copy th value to the new field, the transofmer PBI is not asking for this
            // TODO check Sebrina, Should we answer this question to default https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=ff680cfe-6b2b-f011-8c4c-000d3a8f158d

            // bcbs_chiro_limit_type
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=af14b377-066f-ec11-8941-00224804a95e
            const bcbs_chiro_limit_type_mat = fieldInfosMemoized()[$matt_$medical_$bcbs_chiro_mon_or_max_id];

            const bcbs_chiro_limit_type_value = bcbs_chiro_limit_type_mat?.[0].field?.values?.[0].value?.type === 'entity'
                ? bcbs_chiro_limit_type_mat?.[0].field?.values?.[0].value
                : null;

            // Source:
            // Chiro: Enter Value
            // Single Line Text/no-tier/no-pcp
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=b114b377-066f-ec11-8941-00224804a95e
            const bcbs_chiro_limit_mat = fieldInfosMemoized()[$matt_$medical_$bcbs_chiro_mon_or_max_limit_id];
            const bcbs_chiro_limit_value = bcbs_chiro_limit_mat?.[0].field?.values?.[0].value?.type === 'string'
                ? bcbs_chiro_limit_mat?.[0].field?.values?.[0].value
                : null;

            // Target 1:
            // Chiro Monetary Limit
            // Currency/no-tier/no-pcp
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=2493ec54-ee0f-f011-9989-6045bdef1703
            const bcbs_chiro_monetary_limit_mat = fieldInfosMemoized()[$matt_$medical_$bcbs_chiromonetarylimit_id];
            const bcbs_chiro_monetary_limit_field = bcbs_chiro_monetary_limit_mat[0].field;
            const bcbs_chiro_monetary_limit_value = bcbs_chiro_monetary_limit_mat[0].field.values?.[0];

            // Target 2:
            // Chiro Visit Limit
            // Whole Number/no-tier/no-pcp
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=963e8e04-ef0f-f011-9989-6045bdef1703
            const bcbs_chiro_visit_limit_mat = fieldInfosMemoized()[$matt_$medical_$bcbs_chirovisitlimit_id];
            const bcbs_chiro_visit_limit_field = bcbs_chiro_visit_limit_mat[0].field;
            const bcbs_chiro_visit_limit_value = bcbs_chiro_visit_limit_mat[0].field.values?.[0];


            if (bcbs_chiro_limit_type_value?.id === Monetary.id) {
                // if the type is Monetary then copy the value to the new field
                if (bcbs_chiro_limit_value && bcbs_chiro_monetary_limit_value.value === null) {
                    const valueNumber = this.extractNumber(bcbs_chiro_limit_value.value);
                    if (valueNumber !== null) {
                        bcbs_chiro_monetary_limit_value.value = {
                            type: "number",
                            value: valueNumber,
                        }
                        bcbs_chiro_visit_limit_field.visibility = (bcbs_chiro_visit_limit_field.visibility ?? 0) | EHideReason.ParentVisibility
                        delete bcbs_chiro_monetary_limit_field.visibility;
                    }
                }
            } else if (bcbs_chiro_limit_type_value?.id === Visit.id) {
                // if the type is Visit then copy the value to the new field
                if (bcbs_chiro_limit_value && bcbs_chiro_visit_limit_value.value === null) {
                    const valueNumber = this.extractNumber(bcbs_chiro_limit_value.value);
                    // Convert to whole number (integer)
                    if (valueNumber !== null) {
                        bcbs_chiro_visit_limit_value.value = {
                            type: "number",
                            value: Math.floor(valueNumber),
                        }
                    }
                    bcbs_chiro_monetary_limit_field.visibility = (bcbs_chiro_monetary_limit_field.visibility ?? 0) | EHideReason.ParentVisibility
                    delete bcbs_chiro_visit_limit_field.visibility;
                }
            }
        }




        // Medical Benefit - Inpatient / Outpatient Tab - INPATIENT SERVICES -  SNF BP Max Revisions
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/623228
        // Data Transformer - Medical Benefit - Inpatient / Outpatient Tab - IP SNF Benefit Period Maximum
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/623256
        // TODO check if default yes was needed
        {

            // Source:
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=9415814a-0f10-ed11-b83d-000d3a58ea31
            const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_ipbenfitperiodmaxsnf_id];
            const source_value = source_field?.[0].field?.values?.[0].value?.type === 'string'
                ? source_field?.[0].field?.values?.[0].value
                : null;

            const source_value_number = source_value
                ? this.extractNumber(source_value.value)
                : null;

            // Target 1:
            // Whole Number/no-tier/no-pcp
            // bcbs_snfbp_maxdays
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=ab1edd09-8420-f011-9989-000d3a8f158d
            const bcbs_snfbp_maxdays_mat = fieldInfosMemoized()[$matt_$medical_$bcbs_snfbp_maxdays_id];

            // Target 2:
            // Master Attribute:
            // IP SNF Subject to BP Day Maximums
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=71d83c8f-8420-f011-9989-000d3a8f158d
            const bcbs_ip_snf_subject_to_bp_day_maximums_mat = fieldInfosMemoized()[$matt_$medical_$bcbs_snfdaymaxapply_id];

            if (source_value_number != null) {

                // we need to set the default for this, since parent visiblity depends on this
                const bcbs_ip_snf_subject_to_bp_day_maximums_value = bcbs_ip_snf_subject_to_bp_day_maximums_mat[0].field.values?.[0];
                if (bcbs_ip_snf_subject_to_bp_day_maximums_value.value == null)
                    bcbs_ip_snf_subject_to_bp_day_maximums_value.value = {
                        type: "bool",
                        value: true
                    };

                const bcbs_snfbp_maxdays_value = bcbs_snfbp_maxdays_mat[0].field.values?.[0];
                if (bcbs_snfbp_maxdays_value.value === null) {
                    bcbs_snfbp_maxdays_value.value = {
                        type: "number",
                        value: Math.floor(source_value_number),
                    };
                }

            }
        }


        // Data Transformer - Medical Benefit - Other Services Tab - HEARING AID EXAMS section - Hearing Aid Exams Visit Max change from decimal to whole number
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643603
        {
            // Source:
            // Hearing Aid Hearing Exams Visit Max Amt
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=e9268055-2b7a-ec11-8d21-000d3a34dd4c
            const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_aso_hearingaidhearingexamsunitmaxamt_id];
            const source_value = source_field?.[0].field?.values?.[0].value?.type === 'number'
                ? source_field?.[0].field?.values?.[0].value
                : null;

            // target:
            // Hearing Aid Exams Maximum Visits
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=1b797243-9f52-f011-877a-6045bdec5685
            const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_hearingaidexamsmaximumvisits_id];


            const target_value = target_field?.[0].field?.values?.[0];

            if (source_value && target_value.value === null) {
                // Convert to whole number (integer)
                target_value.value = {
                    type: "number",
                    value: Math.floor(source_value.value),
                };
            }

        }

        // Medical Benefit - Other Services Tab - INFERTILITY BENEFITS section - New and Expired Fields
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643548
        // Data Transformer - Medical Benefit - Other Services Tab - INFERTILITY BENEFITS section - New and Expired Fields
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643551
        {
            // Transform numerical values in If 'Yes', benefit period maximum is: (Infertility) to new field  Infertility Maximum Amount (separate PBI)
            {
                // Source:
                // Infertility: If 'Yes', benefit pd max is:
                // text/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=5d278055-2b7a-ec11-8d21-000d3a34dd4c
                const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_ifyesbenefitperiodmaximumsisinfertility_id];

                // target:
                // Infertility Maximum Amount
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=a726b507-0652-f011-877a-6045bdef1703
                const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_infertilitymaxamt_id];

                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'string'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                if (source_value && target_value.value === null) {

                    const valueNumber = this.extractNumber(source_value.value);

                    if (valueNumber !== null) {
                        target_value.value = {
                            type: "number",
                            value: valueNumber,
                        };
                    }
                }
            }

            // Populate new field Infertility Max Applies Per with Benefit Period when "Are Infertility services subject to max? is Yes.  This is for transformer only (separate PBI)
            {
                const benefitPeriod: FAM_IEntityReferenceValue = {
                    "type": "entity",
                    "entityType": "bcbs_config_optionsetitem",
                    "id": $oset_$os_max_applies_per_$benefit_period_id,
                    "name": "Benefit Period"
                }

                // source:
                // Infertility services subject to max?
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=5b278055-2b7a-ec11-8d21-000d3a34dd4c
                const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_areinfertilityservicessubjecttoanymaximum_id];


                // target:
                // Infertility Max Applies Per
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=4a67c87e-0652-f011-877a-6045bdef1703
                const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_infertilitymaxappliesper_id];

                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'bool'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                if (source_value && source_value.value === true && target_value.value === null) {
                    target_value.value = {
                        type: "entity",
                        id: benefitPeriod.id,
                        name: benefitPeriod.name,
                        entityType: benefitPeriod.entityType,
                    };
                }

            }
        }


        // Medical Benefit - Other Services Tab - NUTRITIONAL COUNSELING section - New and Expired Fields
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/642883
        // Data Transformer - Medical Benefit - Other Services Tab - NUTRITIONAL COUNSELING section - New and Expired Fields
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643095
        // TODO is fully insured needed here?
        {

            const isFullyInsured = this.json.fundingType?.value === IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode["Fully Insured(808900002)"].value;
            // Upon snapshots where Funding Types do not equal Fully Insured and the Effective Date is 10/1/2025 and later, data transforms as follows:
            if (!isFullyInsured && this.isConfigurationED1012025) {
                {
                    // source:
                    // Nutritional Counseling Visit Max Amt
                    // decimal/no-tier/no-pcp
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=7b278055-2b7a-ec11-8d21-000d3a34dd4c
                    const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_aso_nutritionalcounselingvisitmaxamt_id];

                    // target:
                    // Nutritional Counseling Maximum Visits
                    // whole number/no-tier/no-pcp
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=6831b97a-2c51-f011-877a-7ced8d22c030
                    const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_nutritionalmaxvisits_id];

                    const source_value = source_field?.[0].field?.values?.[0].value?.type === 'number'
                        ? source_field?.[0].field?.values?.[0].value
                        : null;

                    const target_value = target_field?.[0].field?.values?.[0];

                    if (source_value && target_value.value === null) {
                        // Convert to whole number (integer)
                        if (Math.floor(source_value.value) > 0)
                            target_value.value = {
                                type: "number",
                                value: Math.floor(source_value.value),
                            };
                    }
                }

                {

                    // source:
                    // Nutritional Counseling Day Max Amt
                    // decimal/no-tier/no-pcp
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=7d278055-2b7a-ec11-8d21-000d3a34dd4c
                    const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_aso_nutritionalcounselingdaymaxamt_id];

                    // target:
                    // Nutritional Counseling Maximum Visits
                    // whole number/no-tier/no-pcp
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=6831b97a-2c51-f011-877a-7ced8d22c030
                    const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_nutritionalmaxvisits_id];

                    const source_value = source_field?.[0].field?.values?.[0].value?.type === 'number'
                        ? source_field?.[0].field?.values?.[0].value
                        : null;

                    const target_value = target_field?.[0].field?.values?.[0];

                    if (source_value && target_value.value === null) {
                        // Convert to whole number (integer)
                        if (Math.floor(source_value.value) > 0)
                            target_value.value = {
                                type: "number",
                                value: Math.floor(source_value.value),
                            };
                    }

                }

                // *Optionset is the same for both source and target
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionset&id=8245a88f-547a-ec11-8d21-000d3a5b9156 
                {
                    // source:
                    // Nutritional Counseling Day Max applies per
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=82278055-2b7a-ec11-8d21-000d3a34dd4c
                    const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_aso_nutritionalcounselingdaymaxapplies_id];

                    // target:
                    // Nutritional Counseling Visit Max applies per
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=80278055-2b7a-ec11-8d21-000d3a34dd4c
                    const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_aso_nutritionalcounselingvisitmaxapplies_id];

                    const source_value = source_field?.[0].field?.values?.[0].value?.type === 'entity'
                        ? source_field?.[0].field?.values?.[0].value
                        : null;

                    const target_value = target_field?.[0].field?.values?.[0];

                    if (source_value && target_value?.value === null) {
                        // Copy the value from source to target
                        target_value.value = {
                            type: "entity",
                            id: source_value.id,
                            name: source_value.name,
                            entityType: source_value.entityType,
                        };
                    }

                }


            }

        }


        // Data Transformer - Medical Benefit - Other Services Tab - PRIVATE DUTY NURSING section - Expire Maximum Days Attribute and correct label and field placement of PDN Day Max applies per
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/642114
        // Summary:
        // transfer "PDN Visit Max Amt" to "PDN Visit Maximum"
        // transofer "PDN Day Max Amt" to "PDN Visit Maximum"
        // "PDN Visit Max Amt" takes precedence over "PDN Day Max Amt"
        {
            // Transfer PDN Visit Max Amt to PDN Visit Maximum
            {
                // Source:
                // PDN Visit Max Amt
                // decimal/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=1f278055-2b7a-ec11-8d21-000d3a34dd4c
                const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_aso_pdnvisitmaxamt_id];

                // target:
                // PDN Visit Maximum
                // whole number/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=f8a4da70-fa51-f011-877a-6045bdef1703
                const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_pdn_visitmaximum_id];

                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'number'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                if (source_value && target_value.value === null) {
                    // Convert to whole number (integer)
                    if (Math.floor(source_value.value) > 0)
                        target_value.value = {
                            type: "number",
                            value: Math.floor(source_value.value),
                        };
                }
            }

            // PDN Visit Max Amt has a higher precedence than PDN Day Max Amt since if both are present, PDN Visit Max Amt is used.
            {
                // Source:
                // PDN Day Max Amt
                // decimal/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=25278055-2b7a-ec11-8d21-000d3a34dd4c
                const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_aso_pdndaymaxamt_id];


                // target:
                // PDN Visit Maximum
                // whole number/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=f8a4da70-fa51-f011-877a-6045bdef1703
                const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_pdn_visitmaximum_id];

                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'number'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                if (source_value && target_value.value === null) {
                    // Convert to whole number (integer)
                    if (Math.floor(source_value.value) > 0) {

                        target_value.value = {
                            type: "number",
                            value: Math.floor(source_value.value),
                        };
                    }

                }
            }

            // *Optionset is the same for both source and target
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionset&id=8245a88f-547a-ec11-8d21-000d3a5b9156 
            {
                // Source
                // PDN Day Max applies per
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=21278055-2b7a-ec11-8d21-000d3a34dd4c
                const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_aso_pdndaymaxappliesper_id];

                // Target:
                // PDN Visit Max applies per
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=27278055-2b7a-ec11-8d21-000d3a34dd4c
                const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_aso_pdnvisitmaxappliesper_id];



                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'entity'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                if (source_value && target_value.value === null) {
                    // Copy the value from source to target
                    target_value.value = {
                        type: "entity",
                        id: source_value.id,
                        name: source_value.name,
                        entityType: source_value.entityType,
                    };
                }

            }
        }


        // Data Transformer- Medical Benefit - Other Services Tab - HOME HEALTHCARE BENEFITS section - Expire Maximum Days Attribute
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/642018
        {
            {
                // source:
                // Maximum Visits
                // text/no-tier/no-pcp/1 attribute
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=0b278055-2b7a-ec11-8d21-000d3a34dd4c
                const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_ifyesbenefitperiodmaximumsishomehealth_id];

                // target:
                // Visit Maximum
                // whole number/no-tier/no-pcp/1 attribute
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=cf0e6fc0-0c52-f011-877a-6045bdef1703
                const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_homehealthvisitmax_id];

                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'string'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                if (source_value && target_value.value === null) {
                    // Convert to whole number (integer)
                    const valueNumber = this.extractNumber(source_value.value);
                    if (valueNumber !== null) {
                        target_value.value = {
                            type: "number",
                            value: Math.floor(valueNumber),
                        };
                    }
                }
            }

            {
                // source:
                // Maxium Days
                // whole number/no-tier/no-pcp/1 attribute
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=11278055-2b7a-ec11-8d21-000d3a34dd4c
                const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_maximumdayshomehealthcare_id];

                // target:
                // Visit Maximum
                // whole number/no-tier/no-pcp/1 attribute
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=cf0e6fc0-0c52-f011-877a-6045bdef1703
                const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_homehealthvisitmax_id];


                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'number'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                if (source_value && target_value.value === null) {
                    // Convert to whole number (integer)
                    if (Math.floor(source_value.value) > 0)
                        target_value.value = {
                            type: "number",
                            value: Math.floor(source_value.value),
                        };
                }

            }
        }

        // Medical Benefit - Other Services Tab - TRAVEL AND LODGING section - New and Expired Fields
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643213
        // Data Transformer - Medical Benefit - Other Services Tab - TRAVEL AND LODGING section - New and Expired Fields
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643489
        {

            {
                // source:
                // applicable maximum
                // If 'Yes', please indicate any applicable maximum here:
                // text/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=4d278055-2b7a-ec11-8d21-000d3a34dd4c
                const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_ifyespleaseindicateanyapplicablemaxtrav_id];

                // target:
                // maximum amount
                // Recipient/ Family Travel and Lodging Maximum Amount
                // currency/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=60cad7b9-ea51-f011-877a-6045bdef1703
                const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_hot_recipientmaximum_id];

                // tagert2:
                // Is Recipient/ Family Travel and Lodging subject to a Monetary Maximum?
                // boolean/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=84b24879-e951-f011-877a-6045bdef1703
                const target2_field = fieldInfosMemoized()[$matt_$medical_$bcbs_hot_recipientsubjecttomax_id];

                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'string'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                const target2_value = target2_field?.[0].field?.values?.[0];

                if (source_value && target_value.value === null) {
                    // Convert to whole number (integer)
                    const valueNumber = this.extractNumber(source_value.value);
                    if (valueNumber !== null) {
                        target_value.value = {
                            type: "number",
                            value: Math.floor(valueNumber),
                        };

                        target2_value.value = {
                            type: "bool",
                            value: true,
                        }
                    }
                }
            }

            // same optionset
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionset&id=9045a88f-547a-ec11-8d21-000d3a5b9156
            {
                // source:
                // Apply maximum per
                // optionset/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=8470ab21-d07a-ec11-8d21-000d3a35957e
                const source_field = fieldInfosMemoized()[$att_$medical_$bcbs_applymaximumperd1_8470ab21d07aec118d21000d3a35957e_id];

                // target:
                // Apply Recipient/Family Maximum Per:
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=1d1858c9-f151-f011-877a-6045bdef1703
                const target_field = fieldInfosMemoized()[$att_$medical_$bcbs_applymaximumperd1_1d1858c9f151f011877a6045bdef1703_id];

                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'entity'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                if (source_value && target_value.value === null) {
                    // Copy the value from source to target
                    target_value.value = {
                        type: "entity",
                        id: source_value.id,
                        name: source_value.name,
                        entityType: source_value.entityType,
                    };
                }
            }

            {
                // source:
                // applicable maximum
                // If 'Yes', please indicate any applicable maximum here:
                // text/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=53278055-2b7a-ec11-8d21-000d3a34dd4c
                const source_field = fieldInfosMemoized()[$matt_$medical_$bcbs_ifyespleaseindicateanyapplicablemaxdonor_id];

                // target:
                // maximum amount
                // Donor/Family Travel and Lodging Maximum Amount
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=73ae3065-eb51-f011-877a-6045bdef1703
                const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_hot_donormaximum_id];

                // tagert2:
                // Is Donor/Family Travel and Lodging subject to a Monetary Maximum?
                // boolean/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=5055ebf9-eb51-f011-877a-6045bdef1703
                const target2_field = fieldInfosMemoized()[$matt_$medical_$bcbs_hot_donorsubjecttomax_id];

                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'string'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                const target2_value = target2_field?.[0].field?.values?.[0];

                if (source_value && target_value.value === null) {

                    // Convert to whole number (integer)
                    const valueNumber = this.extractNumber(source_value.value);
                    if (valueNumber !== null) {
                        target_value.value = {
                            type: "number",
                            value: Math.floor(valueNumber),
                        };

                        target2_value.value = {
                            type: "bool",
                            value: true,
                        }
                    }
                }
            }

            // same optionset
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionset&id=9045a88f-547a-ec11-8d21-000d3a5b9156
            {
                // source:
                // Apply maximum per
                // optionset/no-tier/no-pcp
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=8a70ab21-d07a-ec11-8d21-000d3a35957e
                const source_field = fieldInfosMemoized()[$att_$medical_$bcbs_applymaximumperdonor_8a70ab21d07aec118d21000d3a35957e_id];

                // target:
                // Apply Donor/Family Maximum Per:
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=c407a663-f251-f011-877a-6045bdef1703
                const target_field = fieldInfosMemoized()[$att_$medical_$bcbs_applymaximumperdonor_c407a663f251f011877a6045bdef1703_id];

                const source_value = source_field?.[0].field?.values?.[0].value?.type === 'entity'
                    ? source_field?.[0].field?.values?.[0].value
                    : null;

                const target_value = target_field?.[0].field?.values?.[0];

                if (source_value && target_value.value === null) {
                    // Copy the value from source to target
                    target_value.value = {
                        type: "entity",
                        id: source_value.id,
                        name: source_value.name,
                        entityType: source_value.entityType,
                    };
                }
            }
        }


        // Medical Benefit - Inpatient / Outpatient Tab - PRE AUTHORIZATION REQUIREMENTS section rework
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/633058
        // Data Transformer - Medical Benefit - Inpatient / Outpatient Tab - Transform IP Facility Penalty Amounts
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/633092
        {
            // Source:
            // Others - Pre Auth: Out of Network Penalty Amount
            // text/tiered/no-pcp
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=818b0bc2-a215-ed11-b83c-00224820a835&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=3ea86ae4-ed73-ec11-8941-000d3a352e43
            const source_field = fieldInfosMemoized()[$att_$medical_$bcbs_outofnetworkpenaltyamount_id];

            // Target:
            // IP Penalty Amount
            // whole number/tiered/no-pcp
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=818b0bc2-a215-ed11-b83c-00224820a835&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=51cf4b85-383b-f011-b4cc-7ced8d22c030
            const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_ippenaltyamt_id];

            // const source_value = source_field?.[0].field?.values?.[0].value?.type === 'string'
            //     ? source_field?.[0].field?.values?.[0].value
            //     : null;
            // const target_value = target_field?.[0].field?.values?.[0];

            // if (source_value && target_value.value === null) {
            //     // Copy the value from source to target
            //     target_value.value = {
            //         type: "string",
            //         value: source_value.value,
            //     };
            // }

            const source_values = uniqueFieldValues(source_field);

            const target_values = uniqueFieldValues(target_field);

            Object.keys(source_values).forEach((ukey) => {
                const source_value = source_values[ukey];
                const target_value = target_values[ukey];

                if (source_value.value && target_value.value === null) {

                    const valueString = source_value.value.type === 'string' ? source_value.value.value : null;

                    const valueNumber = valueString ? this.extractNumber(valueString) : null;

                    if (valueNumber !== null && valueNumber > 0)
                        target_value.value = {
                            type: "number",
                            value: Math.floor(valueNumber),
                        };
                }
            });
        }

        // Data Transformer - Medical Benefit - Other Services Tab - COCHLEAR IMPLANTS - Decimal to Whole Number
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/650912
        {
            // Source:
            // Cochlear Implants Unit Max Amt
            // decimal/no-tier/no-pcp
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=3070ab21-d07a-ec11-8d21-000d3a35957e

            // Target:
            // Cochlear Implants Unit Maximum
            // whole number/no-tier/no-pcp
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=7871b501-686d-f011-bec2-6045bded958c

            const source_field = fieldInfosMemoized()[$att_$medical_$bcbs_aso_cochlearimplantsunitmaxamt_id];

            const target_field = fieldInfosMemoized()[$matt_$medical_$bcbs_cochlearmaximum_id];

            const source_value = source_field?.[0].field?.values?.[0].value?.type === 'number'
                ? source_field?.[0].field?.values?.[0].value
                : null;

            const target_value = target_field?.[0].field?.values?.[0];

            if (source_value && target_value && target_value.value === null) {
                target_value.value = {
                    type: "number",
                    value: Math.floor(source_value.value),
                };
            }

        }

        function uniqueFieldValues(source_field: IFlexibleFieldWithAttributes[]) {
            const sourcefileds: Record<string, FAM_IFlexibleFieldValue> = {};
            source_field?.[0].field?.values.forEach((value) => {
                const ukey = `${value.type}-${value.tierRef?.id}`;
                sourcefileds[ukey] = value;
            });
            return sourcefileds;
        }
    }

    async after(json: FAM_IGroupConfigurationData): Promise<void> {

        console.debug("[tran] Sprint40Transformer.after")

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/623228/
        // Review SNF Benefit Period Maximums for accuracy
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isASOFundingTypes)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.SNFBenefitPeriodMaximums,
            });

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/610573/
        // Data re-entry is required for Therapy Maximums - please navigate to new section and update accordingly
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isASOFundingTypes)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.TherapyMaximums,
            });

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/623745/
        // Review Contract Maximums for accuracy
        // All Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.ContractMaximums,
            });

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/633058/
        // Data re-entry is required for the Pre Auth section - please navigate to the section and update accordingly
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isASOFundingTypes)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.PreAuthSection,
            });

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/642016/ 
        // Review Home Health Maximum Visits for accuracy
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isASOFundingTypes)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.HomeHealthMaximumVisits,
            });

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/642098/
        // Review PDN Visit Amts for accuracy
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isASOFundingTypes)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.PDNVisitAmounts,
            });

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643213/
        // Review Travel and Lodging Maximums for accuracy
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isASOFundingTypes)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.TravelAndLodgingMaximums,
            });

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643548/
        // Review Infertility Maximums for accuracy
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isASOFundingTypes)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.InfertilityMaximums,
            });

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643585/
        // Review Hearing Aid Exams Maximum Visits for accuracy
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isASOFundingTypes)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.HearingAidExamsMaximumVisits,
            });


        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/647959
        // Release Messages - Medical Benefit - Therapy Tab - Chiro Limit Value - Fully Insured
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isFullyInsured)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.ReviewChrioLimits,
            });


        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/643585/
        // Review Cochlear Implant Unit Maximums for accuracy
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isASOFundingTypes)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.CochlearImplantUnitMaximums,
            });

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/652161
        // Review Nutritional Counseling for accuracy
        // ASO Funding Types - Configuration ED 10/1/2025
        if (this.isConfigurationED1012025 && this.isASOFundingTypes)
            this.json.notifications!.push({
                id: uuidv4(),
                name: ENotificationName.NutritionalCounseling,
            });


        if (!json.transformers)
            json.transformers = {};

        json.transformers.Sprint40 = true
    }
}
